module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAADNJREFUKFNj/P///yYGBgZfBsJgM+P////vMTAwKBJWy3B/VDFSKNE4NDYzMDD4EBEpmwH9fDUde9OpVwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/stop.png
// module id = vJYh
// module chunks = 2